export default function checkIfAutofillEnabled() {
  return process.env.INTAKE_NOTE_AUTOFILL_ENABLED === 'true'
}
